import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GroupsService } from "../../services/groups.service";

@Component({
	selector: "app-view-details",
	templateUrl: "./view-details.component.html",
	styleUrls: ["./view-details.component.css", "../../groups.css"],
})
export class ViewDetailsComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, public ref: DynamicDialogRef, private groupService: GroupsService) {}

	ngOnInit(): void {
		this.SelectedEventScanID = this.dialogConfig.data.SelectedEventScanID;
		this.loadData();
	}

	///////////////////////////
	// Data
	///////////////////////////

	scanData: any = [];
	SelectedEventScanID: -1;

	selectedDetails = {
		EventDescShort: "",
		EventDescLong: "",
		EventLocation: "",
		StudentID: 0,
		StudentName: "",
		ScanResult: "",
		ScanDateTime: "",
		ScanStation: "",
	};

	CancelViewDetailsClick() {
		this.ref.close(0);
	}

	///////////////////////////

	///////////////////////////
	// Load Data
	///////////////////////////

	private loadData() {
		var result = this.groupService.loadScan("", this.SelectedEventScanID);
		result.subscribe(
			(response) => {
				this.scanData = response;
				this.UpdateData();
			},
			(error) => {}
		);
	}

	UpdateData() {
		this.selectedDetails.EventDescShort = this.scanData[0].EventDescShort;
		this.selectedDetails.EventDescLong = this.scanData[0].EventDescLong;
		this.selectedDetails.EventLocation = this.scanData[0].EventLocation;
		this.selectedDetails.StudentID = this.scanData[0].StudentID;
		this.selectedDetails.StudentName = this.scanData[0].PersonName;
		this.selectedDetails.ScanResult = this.scanData[0].EventScanTypeDesc;
		this.selectedDetails.ScanDateTime = this.scanData[0].EventScanDT;
		this.selectedDetails.ScanStation = this.scanData[0].ScanStation;
	}

	///////////////////////////
}
